// extracted by mini-css-extract-plugin
export var attachment = "_p9-a";
export var emailContainer = "_p9-4";
export var emailContentPaddedContainer = "_p9-b";
export var emailHeader = "_p9-6";
export var emailIframe = "_p9-3";
export var emailInfoIcon = "_p9-9";
export var emailShortenedSummary = "_p9-e";
export var infoDropdown = "_p9-0";
export var infoRowBoundedContent = "_p9-d";
export var internal = "_p9-5";
export var merchant = "_p9-8";
export var messageInputContainer = "_p9-h";
export var normal = "_p9-7";
export var replyCard = "_p9-f";
export var subtleButton = "_p9-1";
export var subtleButtonIconContainer = "_p9-2";
export var toggleViewRepliesButton = "_p9-c";
export var wrappingText = "_p9-g";